import { useMakeModelKeywordSearch } from './MakeModelKeywordSearch.hook';

import { DisplayContainer } from '../../components/Support/DisplayContainer/DisplayContainer';

import type { MakeModelKeywordSearchProps } from './MakeModelKeywordSearch.typed';

/**
 * A search interface for filtering vehicles by make, model, and keywords.
 *
 * Renders different UI based on screen size.
 */
export const MakeModelKeywordSearch = (props: MakeModelKeywordSearchProps) => {
  const {
    modalDisplayConfig,
    dropdownDisplayConfig,
    minPrice,
    maxPrice,
    minYear,
    maxYear,
  } = props;

  useMakeModelKeywordSearch({
    minPrice,
    maxPrice,
    minYear,
    maxYear,
  });

  return (
    <>
      <DisplayContainer config={modalDisplayConfig}>
        {/* TODO: https://distilledsch.tpondemand.com/RestUI/Board.aspx#page=board/5702367192831126523&appConfig=eyJhY2lkIjoiNTY1MTY2MDA0MDAzMEM2ODA3MURCQjQ5M0Y4NDQxQ0MifQ==&boardPopup=userstory/111789/silent */}
        <p>Make Model Keyword Search Mobile</p>
      </DisplayContainer>
      <DisplayContainer config={dropdownDisplayConfig}>
        {/* TODO: https://distilledsch.tpondemand.com/RestUI/Board.aspx#page=board/5702367192831126523&appConfig=eyJhY2lkIjoiNTY1MTY2MDA0MDAzMEM2ODA3MURCQjQ5M0Y4NDQxQ0MifQ==&boardPopup=userstory/111790/silent */}
        <p>Make Model Keyword Search Web</p>
      </DisplayContainer>
    </>
  );
};
